import React from "react";
import { VisuallyHidden } from "@radix-ui/react-visually-hidden";

import { useMediaQuery } from "~/hooks/use-media-query";
import { useRegisterStore } from "~/stores/use-register-store";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "../ui/dialog";
import { Drawer, DrawerContent, DrawerHeader, DrawerTitle } from "../ui/drawer";
import DayOverview from "./day-overview";

export default function DayOverviewDialog() {
  const { dayOverviewOpen, setDayOverviewOpen } = useRegisterStore();
  const isMobile = useMediaQuery(768);

  if (isMobile)
    return (
      <Drawer open={dayOverviewOpen} onOpenChange={setDayOverviewOpen}>
        <DrawerContent className="min-h-[40dvh] overflow-hidden flex flex-col p-0">
          <DrawerHeader
            showClose={true}
            onClose={() => {
              setDayOverviewOpen(false);
            }}
          >
            <DrawerTitle>Day overview</DrawerTitle>
            <VisuallyHidden></VisuallyHidden>
          </DrawerHeader>
          <div className="overflow-auto small-scrollbar">
            <DayOverview />
          </div>
        </DrawerContent>
      </Drawer>
    );

  return (
    <Dialog open={dayOverviewOpen} onOpenChange={setDayOverviewOpen}>
      <DialogContent className="max-w-3xl w-full">
        <DialogHeader>
          <DialogTitle>Day overview</DialogTitle>
          <VisuallyHidden>
            <DialogDescription></DialogDescription>
          </VisuallyHidden>
        </DialogHeader>
        <DayOverview />
      </DialogContent>
    </Dialog>
  );
}
